import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing and using eEvolve.ai ("the Service"), you accept and agree to be bound by the terms and provision of this agreement.
          </Typography>

          <Typography variant="h5" gutterBottom>
            2. Use License
          </Typography>
          <Typography variant="body1" paragraph>
            Permission is granted to temporarily use eEvolve.ai for personal and commercial purposes. This is the grant of a license, not a transfer of title.
          </Typography>

          <Typography variant="h5" gutterBottom>
            3. Account Creation
          </Typography>
          <Typography variant="body1" paragraph>
            To access certain features, you must create an account. You are responsible for maintaining the confidentiality of your account information.
          </Typography>

          <Typography variant="h5" gutterBottom>
            4. Payment Terms
          </Typography>
          <Typography variant="body1" paragraph>
            All payments are processed through Razorpay. By making a purchase, you agree to their terms of service. All sales are final unless otherwise stated in our refund policy.
          </Typography>

          <Typography variant="h5" gutterBottom>
            5. Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            The Service and its original content, features, and functionality are owned by eEvolve.ai and are protected by international copyright, trademark, and other intellectual property laws.
          </Typography>

          <Typography variant="h5" gutterBottom>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            In no event shall eEvolve.ai, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages.
          </Typography>

          <Typography variant="h5" gutterBottom>
            7. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
          </Typography>

          <Typography variant="h5" gutterBottom>
            8. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify these terms at any time. We will provide notice of any changes by posting the new Terms of Service on this page.
          </Typography>

          <Typography variant="h5" gutterBottom>
            9. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about these Terms, please contact us at service@eevolve.ai.
          </Typography>

          <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary">
              By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service and our <Link to="/privacy">Privacy Policy</Link>.
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfService;